import React from 'react';
import { FDPaper } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const LayoutPaper = ({ children, padding }) => {
  return (
    <FDPaper appearance={'elevated'} padding={padding} width={'100%'}>
      {children}
    </FDPaper>
  );
};

LayoutPaper.defaultProps = {
  padding: 2,
};

LayoutPaper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  padding: PropTypes.number,
};
